import React from "react";

/**
 * Inline SVG icon set.
 * Icons inherit `currentColor` and size from CSS, so they adapt to theme.
 */
const base = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
};

export const ArrowRight = (props) => (
  <svg {...base} {...props}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const ArrowLeft = (props) => (
  <svg {...base} {...props}>
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
);

export const ArrowUp = (props) => (
  <svg {...base} {...props}>
    <path d="M12 19V5M6 11l6-6 6 6" />
  </svg>
);

export const Check = (props) => (
  <svg {...base} strokeWidth={3} {...props}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const Sun = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

export const Moon = (props) => (
  <svg {...base} {...props}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

export const Mail = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="4" width="20" height="16" rx="3" />
    <path d="m3 7 8.4 5.6a2 2 0 0 0 2.2 0L22 7" />
  </svg>
);

export const Leaf = (props) => (
  <svg {...base} {...props}>
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6" />
  </svg>
);

export const Truck = (props) => (
  <svg {...base} {...props}>
    <path d="M14 17V5a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1" />
    <path d="M14 8h4l3 3.5V16a1 1 0 0 1-1 1h-1" />
    <circle cx="6.5" cy="17.5" r="2" />
    <circle cx="17.5" cy="17.5" r="2" />
  </svg>
);

export const Instagram = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="3.6" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const LinkedIn = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <path d="M7.5 10.5V17" />
    <circle cx="7.5" cy="7.3" r="1.1" fill="currentColor" stroke="none" />
    <path d="M11.5 17v-3.6a2.4 2.4 0 0 1 4.8 0V17M11.5 17v-6.5" />
  </svg>
);

export const Discord = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M19.27 5.33A16.6 16.6 0 0 0 15.1 4l-.2.38a15.4 15.4 0 0 1 3.67 1.2 12.9 12.9 0 0 0-12-.02c1.16-.53 2.4-.93 3.68-1.18L10.05 4a16.6 16.6 0 0 0-4.17 1.33C3.2 9.3 2.48 13.17 2.84 16.98a16.7 16.7 0 0 0 5.08 2.56l.99-1.6a10.9 10.9 0 0 1-1.7-.82l.42-.32a11.9 11.9 0 0 0 10.1 0l.42.32c-.54.32-1.11.6-1.7.82l.98 1.6a16.7 16.7 0 0 0 5.09-2.56c.42-4.42-.72-8.25-3.25-11.65ZM9.23 14.65c-.99 0-1.8-.9-1.8-2.01 0-1.11.8-2.02 1.8-2.02s1.82.91 1.8 2.02c0 1.1-.8 2.01-1.8 2.01Zm5.54 0c-.99 0-1.8-.9-1.8-2.01 0-1.11.8-2.02 1.8-2.02s1.81.91 1.8 2.02c0 1.1-.8 2.01-1.8 2.01Z" />
  </svg>
);

export const MapPin = (props) => (
  <svg {...base} {...props}>
    <path d="M20 10c0 5.5-8 12-8 12s-8-6.5-8-12a8 8 0 1 1 16 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const Clock = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const Shield = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6l7-3z" />
    <path d="M9.5 12l1.8 1.8 3.4-3.6" />
  </svg>
);

export const Users = (props) => (
  <svg {...base} {...props}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20a6 6 0 0 1 12 0" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 5.6M17.5 14.4A6 6 0 0 1 21 20" />
  </svg>
);

export const CreditCard = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="5" width="19" height="14" rx="3" />
    <path d="M2.5 10h19M6 15h3" />
  </svg>
);

export const Package = (props) => (
  <svg {...base} {...props}>
    <path d="M21 8.5v7a2 2 0 0 1-1 1.73l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 3 15.5v-7a2 2 0 0 1 1-1.73l7-4a2 2 0 0 1 2 0l7 4A2 2 0 0 1 21 8.5z" />
    <path d="m3.3 7.5 8.7 5 8.7-5M12 22v-9.5" />
  </svg>
);

export const Calendar = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);

export const Sprout = (props) => (
  <svg {...base} {...props}>
    <path d="M12 21v-8" />
    <path d="M12 13c0-3.3-2.7-6-6-6H4v1.5A5.5 5.5 0 0 0 9.5 14H12z" />
    <path d="M12 13c0-3 2.5-5.5 5.5-5.5H20v1A5.5 5.5 0 0 1 14.5 14H12z" />
  </svg>
);
